export default __webpack_public_path__ + "static/media/img-merchant-wallet-app-banner-new.1bd45adf.png";